import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem("legaltitan_lang") || "hy";
    });

    useEffect(() => {
        localStorage.setItem("legaltitan_lang", currentLanguage);
        document.documentElement.lang = currentLanguage;
    }, [currentLanguage]);

    const changeLanguage = (lang) => {
        if (translations[lang]) {
            setCurrentLanguage(lang);
        }
    };

    const t = (path) => {
        const keys = path.split(".");
        let result = translations[currentLanguage];
        for (const k of keys) {
            if (result && result[k] !== undefined) {
                result = result[k];
            } else {
                // Fallback to Armenian
                let fallback = translations["hy"];
                for (const fk of keys) {
                    if (fallback && fallback[fk] !== undefined) {
                        fallback = fallback[fk];
                    } else {
                        return path;
                    }
                }
                return fallback;
            }
        }
        return result;
    };

    return (
        <LanguageContext.Provider value={{ currentLanguage, changeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};
